import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExternalLoginComponent } from './external-login/external-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ResetPasswordComponent } from './external-login/reset-password/reset-password.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ExternalHomeComponent } from './external-home/external-home.component';
import { ExternalValidationComponent } from './external-validation/external-validation.component';
import { ChangePasswordComponent } from './external-home/change-password/change-password.component';
import { NoAccessComponent } from './external-home/no-access/no-access.component';
import { CrewDetailsComponent } from './external-home/crew-details/crew-details.component';
import { FlightModule } from 'src/app/flight/fight.module';

@NgModule({
  declarations: [
    ExternalLoginComponent,
    ResetPasswordComponent,
    ExternalHomeComponent,
    ExternalValidationComponent,
    ChangePasswordComponent,
    NoAccessComponent,
    CrewDetailsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    MatDialogModule,
    FormsModule,
    FlightModule
  ],
  exports: [
    ExternalLoginComponent
  ]
})
export class ExternalModule { }
